// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3978
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { FeatureLine } from "../enums/feature_line";

// Event_name: 'send.dropbox_ai_feedback'
// Description: When user clicks thumb down for Answers/ Chat response, a modal would pop up asking for feedback. This event triggers when the s"Submit" button is clicked.
// Owner: dash-web
export type Send_DropboxAiFeedback = PAPEventGeneric<
  'dash',
  'send',
  'dropbox_ai_feedback',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // fresh id that gets generated for every new session or instance of the chat window
    chatSessionId?: string;
    // randomly generated uuid v4 for a Dash Answers conversation
    conversationId?: string;
    // User product feedback typed into an open text form. Make an effort to scrub common PII like emails, file paths, and phone numbers when using this. According to drl/dataclassification, this is L1 user data allowed in PAP as a RESTRICTED property.
    openFeedback?: string;
  }
>;

export function PAP_Send_DropboxAiFeedback(properties?: Send_DropboxAiFeedback['properties']): Send_DropboxAiFeedback {
  return <Send_DropboxAiFeedback>{
    class: 'dash',
    action: 'send',
    object: 'dropbox_ai_feedback',
    properties,
  };
}
